export interface Upgrade {
  id: string;
  name: string;
  description: string;
  icon: string;
  apply: () => void;
}

export enum UpgradeType {
  DAMAGE = 'damage',
  ATTACK_SPEED = 'attack_speed',
  MOVE_SPEED = 'move_speed',
  MAX_HEALTH = 'max_health',
  HEAL = 'heal',
  PROJECTILE_SPEED = 'projectile_speed',
  MAGNET_RANGE = 'magnet_range'
}
